import styled from 'styled-components/macro';
import { Button } from '@redis-ui/components';

export const SendNewActivationLinkBtn = styled(Button)`
  align-self: flex-end;
  margin-top: 5rem;
`;
